function attribution() {
  !function r(n, s, a) {
    function o(t, e) {
      if (!s[t]) {
        if (!n[t]) {
          var i = "function" == typeof require && require;
          if (!e && i) return i(t, !0);
          if (c) return c(t, !0);
          throw (e = new Error("Cannot find module '" + t + "'")).code = "MODULE_NOT_FOUND", e
        }
        i = s[t] = {exports: {}}, n[t][0].call(i.exports, function (e) {
          return o(n[t][1][e] || e)
        }, i, i.exports, r, n, s, a)
      }
      return s[t].exports
    }

    for (var c = "function" == typeof require && require, e = 0; e < a.length; e++) o(a[e]);
    return o
  }({
    1: [function (e, t, i) {
      var r = e("../dom-helpers/domHelpers"), n = e("../json-storage/JSONStorage"), s = e("../campaignData"),
        a = "_ca_data";

      function o(e, t) {
        return this._instance || ((this._instance = this)._historyTracker = t, this._hiddenFieldValue = "", this._globalCloudAmp = e, this.userDefinedForms = this._globalCloudAmp.forms || [], this._campaignTrackerId = this._globalCloudAmp.name || "cloudamp__data__c", this._globalCloudAmp.populateForm = this._bindPopulateForm(this), this.validForms = this._getValidForms(), this._run(), this)
      }

      e = o.prototype;
      e._run = function () {
        this._visitDataExists() || this._storeVisitData(document.referrer), 0 < this.validForms.length && this._appendHiddenFields()
      }, e._visitDataExists = function () {
        var e = n.getItem(a);
        return s.campaignDataExists(e)
      }, e._storeVisitData = function (e) {
        e = s.getCampaignData(e);
        n.setItem(a, e)
      }, e.populateForm = function (e, t) {
        var i;
        t = t || this._campaignTrackerId, this._hiddenFieldValue = this._hiddenFieldValue || this._createHiddenFieldValue(), !e.nodeType || 1 !== e.nodeType && 11 !== e.nodeType || ((i = r.getFormField(e, t)) ? i.value = this._hiddenFieldValue : (i = r.createHiddenField(t, this._hiddenFieldValue), e.appendChild(i)))
      }, e._bindPopulateForm = function (t) {
        return function () {
          var e = Array.prototype.slice.call(arguments);
          t.populateForm.apply(t, e)
        }
      }, e._getValidForms = function () {
        for (var e, t, i, r, n = document.forms, s = n.length, a = [], o = 0; o < s; o += 1) for (t = n[o], e = 0; e < t.length; e += 1) "object" != typeof (i = t[e]) || void 0 === i.name || "oid" !== i.name && i.name !== this._campaignTrackerId || a.push({id: t});
        if (this.userDefinedForms && 0 < this.userDefinedForms.length) for (r = this.userDefinedForms.length, o = 0; o < r; o += 1) "object" == typeof this.userDefinedForms[o] && this.userDefinedForms[o].id && ("string" == typeof this.userDefinedForms[o].id && (this.userDefinedForms[o].id = document.getElementById(this.userDefinedForms[o].id)), this.userDefinedForms[o].id) && 1 === this.userDefinedForms[o].id.nodeType && "form" === this.userDefinedForms[o].id.nodeName.toLowerCase() && a.push(this.userDefinedForms[o]);
        return a
      }, e._createHiddenFieldValue = function () {
        var e = "", t = n.getItem(a), i = this._historyTracker.load(), r = {};
        return r.campaignData = t, r.campaignData.GAReferer = document.referrer, r.history = i, e += JSON.stringify(r), 13e4 < (e = encodeURIComponent(e)).length && (r.history.sessions = [], e = JSON.stringify(r), e = encodeURIComponent(e), this._historyTracker._save()), e
      }, e._appendHiddenFields = function () {
        for (var e, t = this.validForms.length, i = 0; i < t; i += 1) e = this.validForms[i].name || this._campaignTrackerId, this.populateForm(this.validForms[i].id, e)
      }, t.exports = o
    }, {"../campaignData": 2, "../dom-helpers/domHelpers": 4, "../json-storage/JSONStorage": 6}],
    2: [function (e, t, i) {
      !function () {
        "use strict";
        var n = e("./strings"), s = e("./visit");
        t.exports = {
          getCampaignData: function (e) {
            var t = s.data(e), i = {};
            if (t) for (var r in t) r in n.queryParams ? i[n.queryParams[r]] = t[r] : i[r] = t[r];
            return i
          }, campaignDataExists: function (e) {
            var t = !1;
            if (e && "object" == typeof e) for (var i in n.queryParams) if (n.queryParams[i] in e && e[n.queryParams[i]]) {
              t = !0;
              break
            }
            return t
          }
        }
      }()
    }, {"./strings": 8, "./visit": 9}],
    3: [function (e, t, i) {
      var r, n;
      r = window, function () {
        var e = "__cloudamp__";
        try {
          return localStorage.setItem(e, e), localStorage.removeItem(e), 1
        } catch (e) {
        }
      }() && "JSON" in window && "parse" in JSON && "stringify" in JSON && (n = e("./campaign-tracker/CampaignTracker"), e = new (e("./history-tracker/HistoryTracker"))(document.referrer), r._cloudAmp = r._cloudAmp || {}, new n(r._cloudAmp, e), t.exports = n)
    }, {"./campaign-tracker/CampaignTracker": 1, "./history-tracker/HistoryTracker": 5}],
    4: [function (e, t, i) {
      t.exports = {
        filterScriptTags: function (e, t) {
          var i, r, n, s, a = [];
          if (e && t && (i = e.length, r = t.length, 0 < i) && 0 < r) for (n = 0; n < i; n += 1) for (s = 0; s < r; s += 1) t[s].test(e[n].src) && a.push(e[n]);
          return a
        }, scriptsLoaded: function (e) {
          for (var t = e.length, i = 0; i < t; i += 1) if (!1 === e[i].loaded) return !1;
          return !0
        }, createHiddenField: function (t, i) {
          var r;
          try {
            r = document.createElement('<input type="hidden" name="' + t + '" value="' + i + '" />')
          } catch (e) {
            (r = document.createElement("input")).type = "hidden", r.value = i, r.setAttribute("name", t)
          }
          return r
        }, getFormField: function (e, t) {
          for (var i, r = e.length, n = 0; n < r; n += 1) if ("object" == typeof (i = e[n]) && void 0 !== i.name && i.name === t) return i
        }
      }
    }, {}],
    5: [function (e, t, i) {
      "use strict";

      function r(e) {
        this._history = this.load(), this._setInitials(e), this._logPage(), this._save()
      }

      var n = "_ca_history", s = e("../json-storage/JSONStorage"), a = e("../visit"), o = e("../campaignData"),
        c = a.referringHostname(document.referrer), u = a.isSelfReferring(document.referrer), e = r.prototype;
      e._setInitials = function (e) {
        this._history || (this._history = {}), this.isEntryPage = this._isEntryPage(), this.isEntryPage && this._logInitialReferrer(), this._initSession(e)
      }, e._initSession = function (e) {
        this._activeSession() && !this._sessionExpired() || this._startSession(e)
      }, e._logPage = function () {
        var e = this._activeSession(), t = e.pages.length, t = e.pages[t - 1] || !1, i = document.location.href;
        t && t.url === i || (t = document.getElementsByTagName("head")[0].getElementsByTagName("title")[0], i = {
          url: i.slice(0, 255),
          timestamp: (new Date).getTime(),
          title: t.textContent || t.innerHTML
        }, e.pages.push(i))
      }, e._save = function () {
        s.setItem(n, this._history)
      }, e.load = function () {
        return s.getItem(n) || null
      }, e._makeSession = function (e) {
        var t = {session: this._sessionCount() + 1, pages: [], campaignData: o.getCampaignData(e)};
        return t.campaignData.GAReferrer = e, t
      }, e._startSession = function (e) {
        this._history.sessions || (this._history.sessions = []), this._history.sessions.push(this._makeSession(e))
      }, e._sessionExpired = function () {
        var e = this._lastActivity(), e = 0 <= e ? (new Date).getTime() - e : e;
        return 0 <= e && !u && 18e5 < e ? !0 : !1
      }, e._lastActivity = function () {
        var e = -1, t = this._activeSession(), i = t && t.pages.length ? t.pages.length : 0;
        return e = i ? t.pages[i - 1].timestamp : e
      }, e._activeSession = function () {
        var e, t = null;
        return t = this._history.sessions && (e = this._history.sessions.length) ? this._history.sessions[e - 1] || null : t
      }, e._sessionCount = function () {
        var e, t = 0;
        return t = this._history.sessions && (e = this._history.sessions.length) ? this._history.sessions[e - 1].session : t
      }, e._isEntryPage = function () {
        var e = !0;
        return e = this._history && this._history.initialReferrer && 0 < this._history.initialReferrer.length ? !1 : e
      }, e._logInitialReferrer = function () {
        this._history.initialReferrer = "" === c ? "direct" : c
      }, t.exports = r
    }, {"../campaignData": 2, "../json-storage/JSONStorage": 6, "../visit": 9}],
    6: [function (e, t, i) {
      !function () {
        "use strict";
        t.exports = {
          setItem: function (e, t) {
            t = JSON.stringify(t), localStorage.setItem(e, t)
          }, getItem: function (e) {
            return (e = localStorage.getItem(e) || null) && JSON.parse(e)
          }, clear: function () {
            localStorage.clear()
          }, removeItem: function (e) {
            localStorage.removeItem(e)
          }
        }
      }()
    }, {}],
    7: [function (e, i, t) {
      !function () {
        "use strict";
        var t = /\+/g;

        function a(e) {
          return e = e && "string" == typeof e ? decodeURIComponent(e.replace(t, " ")) : e
        }

        i.exports = {
          parse: function (e) {
            var t, i = {};
            if (e && "string" == typeof e) for (var r, e = a(e), n = (r = (e = "?" === e.charAt(0) ? e.substr(1) : e).split("&")).length, s = 0; s < n; s += 1) 1 < (t = r[s].split("=")).length && (i[t[0]] = t[1]);
            return i
          }, assemble: function (e) {
          }, decode: a
        }
      }()
    }, {}],
    8: [function (e, t, i) {
      !function () {
        "use strict";
        t.exports = {
          queryParams: {
            campaign: "utm_campaign",
            medium: "utm_medium",
            source: "utm_source",
            content: "utm_content",
            utmid: "utm_id",
            term: "utm_term",
            gclid: "gclid",
            msclkid: "msclkid"
          },
          visitTypes: {direct: "direct", referral: "referral", organic: "organic", paid: "paid", tagged: "campaign"},
          searchSources: [/(http(s?):\/\/)?(www\.)?(google\.\w+(\.\w+)?)\//, /(http(s?):\/\/)?(www\.)?((r\.)?search\.yahoo\.\w+(\.\w+)?)\//, /(http(s?):\/\/)?(www\.)?(bing\.\w+(\.\w+)?)\/search/],
          organicSiteNames: ["google", "yahoo", "bing"]
        }
      }()
    }, {}],
    9: [function (h, f, e) {
      !function () {
        "use strict";
        var n = h("./query-string"), e = h("./strings"), s = n.parse(document.location.search), t = /:(?:\/+)(.+?)\//,
          a = e.queryParams, o = e.visitTypes, c = e.searchSources, u = e.organicSiteNames;

        function i(e) {
          var t, i, r = !1;
          if (function (e) {
            for (var t = c.length, i = !1, r = 0; r < t; r += 1) if (e.match(c[r])) {
              i = !0;
              break
            }
            return i
          }(e)) if (a.gclid in s || a.msclkid in s) r = !0; else if (a.campaign in s || a.medium in s) for (r = !0, t = [s[a.campaign], s[a.medium]], i = 0; i < t.length; i += 1) if (t[i] && "organic" === t[i].toLowerCase()) {
            r = !1;
            break
          }
          return r
        }

        function r(e) {
          var t = o.direct;
          return !function () {
            var e, t = !1;
            for (e in a) if (a[e] in s) {
              t = !0;
              break
            }
            return t
          }() ? e && (t = function (e) {
            for (var t = o.referral, i = c.length, r = 0; r < i; r += 1) if (e.match(c[r])) {
              t = o.organic;
              break
            }
            return t
          }(e)) : t = i(e) ? o.paid : o.tagged, t
        }

        function m(e) {
          for (var t in a) a[t] in s && (e[t] = s[a[t]]);
          return e
        }

        function l(e) {
          e = (e = e || document.referrer).match(t);
          return e && e[1] ? e[1] : ""
        }

        function d(e) {
          var t, i = e.split("?")[1], r = n.parse(i), e = l(e);
          return r[t = i && (e && e.match("search.yahoo.com") && (t = "p"), e) && e.match("bing.com") ? "q" : t] || null
        }

        f.exports = {
          referringHostname: l, isSelfReferring: function (e) {
            var t = location.host || location.hostname;
            return l(e) === t
          }, data: function (e) {
            var t, i = {
              type: null,
              campaign: null,
              content: null,
              medium: null,
              source: null,
              term: null,
              gclid: null,
              msclkid: null,
              paidSearch: !1,
              timestamp: (new Date).getTime()
            };
            switch (r(e)) {
              case o.tagged:
                i.type = o.tagged, i = m(i);
                break;
              case o.paid:
                i.type = o.tagged, i.term = d(e), (i = m(i)).campaign = i.campaign || "GoogleAdwords", i.medium = i.medium || "Adwords", i.source = i.source || "GoogleAdwords", i.paidSearch = !0;
                break;
              case o.organic:
                i.type = o.organic, i.campaign = "(organic)", i.medium = "organic", i.source = t = "string" == typeof (t = function (e) {
                  for (var t, i = l(e), r = u.length, n = 0; n < r; n += 1) if (i.match(u[n])) {
                    t = u[n];
                    break
                  }
                  return t
                }(e)) ? t.replace(t.charAt(0), t.charAt(0).toUpperCase()) : t, i.term = d(e) || "(not provided)";
                break;
              case o.referral:
                i.type = o.referral, i.campaign = "(referral)", i.medium = "referral", i.source = l(e);
                break;
              default:
                i.type = o.direct, i.campaign = "(direct)", i.medium = "none", i.source = "(direct)"
            }
            return i
          }
        }
      }()
    }, {"./query-string": 7, "./strings": 8}]
  }, {}, [3]);
}

export default attribution;
